module.exports = __webpack_public_path__ + "img/medal_silver.7a1a7f68.png";